import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { Carousel } from '@components/molecules/Carousel/Carousel';
import { StreamingTeaser } from '@components/molecules/StreamingTeaser/StreamingTeaser';
import { TvCurrentProgram } from '@components/molecules/TvCurrentProgram/TvCurrentProgram';
import {
  type PageContentElementTvmWatchlist as PageContentElementTvmWatchlistType,
  TvmFavoritesShowtimesDocument,
} from '@src/lib/graphql/generated';
import { usePaginatedAuthQuery } from '@src/lib/graphql/urql';
import { useState } from 'react';

export const PageContentElementTvmWatchlist = (
  element: PageContentElementTvmWatchlistType & { favoriteQuery: PageContentElementTvmWatchlistType['query'] },
) => {
  const [lastScroll, setLastScroll] = useState(0);

  const type = element?.favoriteQuery?.type;

  const [{ data: showtimesData, fetching: showtimesLoading }] = usePaginatedAuthQuery({
    query: TvmFavoritesShowtimesDocument,
    variables: {
      orderBy: 'start',
      orderDirection: 'asc',
      first: 20,
      page: 1,
    },
    pause: type !== 'showtimes',
  });

  const showtimes = showtimesData?.flatMap((e) => e?.tvmFavoritesShowtimes?.data)?.filter(Boolean);
  if (
    (type === 'standard' && element?.favoriteQuery?.entities?.length < 1) ||
    (type === 'showtimes' && showtimes?.length < 1 && !showtimesLoading)
  ) {
    return null;
  }

  const entries = type === 'showtimes' ? showtimes : element?.favoriteQuery?.entities;

  return (
    <div className="relative pl-4 sm:pl-8 lg:pl-16">
      <ShowAllTitle title={element.title} link={element.title_link} />
      <section className="space-y-32">
        <Carousel
          onScrollComplete={() => {
            setLastScroll((prev) => prev + 1);
          }}
        >
          {type === 'standard'
            ? entries?.map((entry) => (
                <StreamingTeaser
                  entry={entry?.entity}
                  listicleType={entry?.entity?.__typename === 'Movie' ? 'MOVIE' : 'SHOW'}
                  lastScroll={lastScroll}
                  key={entry?.entity?.id}
                />
              ))
            : entries?.map((entry) => <TvCurrentProgram channelEntry={entry} lastScroll={lastScroll} key={entry.id} />)}
        </Carousel>
      </section>
    </div>
  );
};

export default PageContentElementTvmWatchlist;
